module.exports = __webpack_public_path__ + "static/media/ro.9aac0612.webp";